import { Button, DropDownButton } from "@progress/kendo-react-buttons";
import {
  FormDropDownList,
  FormDatePicker,
  FormMaskedTextBox,
  FormMaskedTextBoxMobile,
  Alert,
} from "@mikros/shared-ui";
import { Field, Form, FormElement } from "@progress/kendo-react-form";
import React, { useState } from "react";
import { InputPicker } from "rsuite";
import { TextBoxProps } from "@progress/kendo-react-inputs";
import { useNavigate } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import ApiServices from "../../service/apiService";
import { Dialog } from "@progress/kendo-react-dialogs";
import { useParams } from "react-router";
import countryCodes, { CountryProperty } from "country-codes-list";
import ErrorHandler from "../../utils/errorConfig";
import { Error } from "@progress/kendo-react-labels";
export interface NewAdminProps {}
export function ManageAdmin(props: NewAdminProps) {
  const navigate = useNavigate();
  const params = useParams();
  const errorInstance = ErrorHandler.getErrorInstance();

  const [formKey, setFormKey] = useState(1);
  const [value, setValue] = useState<TextBoxProps["value"]>(" ");
  const [showtoggle, settoggle] = useState(false);
  const [formCreateDialog, setformCreateDialog] =
    React.useState<boolean>(false);
  const [formUpdateDialog, setformUpdateDialog] =
    React.useState<boolean>(false);
  const [showDialogtext, setShowDialogtext] = React.useState<any>(true);
  const [showAdminUser, setShowAdminUser] = React.useState<any>({});
  const [showButton, setShowButton] = React.useState<any>(true);
  const [showMessage, setShowMessage] = React.useState<any>(true);

  const [extractRole, setExtractRole] = useState<any>();

  //error
  const [errorFlag, setErrorFlag] = useState<boolean>(false);
  const [errors, setErrors] = useState<any>({});

  const intl = useIntl();

  const mobileRegexUpdate: RegExp = /^(\+[0-9]{5,20})$/;

  const toggleformCreateDialog = () => {
    setformCreateDialog(!formCreateDialog);
  };

  const toggleformUpdateDialog = () => {
    setformUpdateDialog(!formUpdateDialog);
  };
  // const complexSimpleModelMapping: { [key: string]: string } = {
  //   "gpt-3.5-turbo-0125": "gpt3p5",
  //   "gpt-4-turbo": "gpt4",
  //   "gpt-4o": "gpt4o",
  // };

  const complexSimpleModelMapping: { [key: string]: string } = {
    [intl.formatMessage({ id: "gptcomplex3.5Turbo" })]: intl.formatMessage({
      id: "gptSimple3p5",
    }),
    [intl.formatMessage({ id: "gptcomplex4Turbo" })]: intl.formatMessage({
      id: "gptSimple4",
    }),
    [intl.formatMessage({ id: "gptcomplex4o" })]: intl.formatMessage({
      id: "gptSimple4o",
    }),
  };

  const validators = {
    mobileNumberValidator: (value: string) =>
      !value
        ? intl.formatMessage({
            id: "organization.mobileNumberValidation",
          })
        : mobileRegex.test(value)
        ? ""
        : intl.formatMessage({
            id: "organization.mobileNumberAnotherValidation",
          }),
    mobileNumberUpdateValidator: (value: string) =>
      !value
        ? intl.formatMessage({
            id: "user.createUser.mobileNumberAnotherValidation",
          })
        : mobileRegexUpdate.test(value)
        ? ""
        : `${intl.formatMessage({
            id: "user.createUser.mobileNumberAnotherValidation",
          })}`,
    firstNameValidator: (value: string) =>
      !value
        ? intl.formatMessage({
            id: "user.createUser.fnameValidation",
          })
        : nameRegex.test(value)
        ? ""
        : intl.formatMessage({
            id: "user.createUser.fnameAnotherValidation",
          }),
    lastNameValidator: (value: string) =>
      !value
        ? intl.formatMessage({
            id: "user.createUser.lnameValidation",
          })
        : nameRegex.test(value)
        ? ""
        : intl.formatMessage({
            id: "user.createUser.lnameAnotherValidation",
          }),
    emailValidator: (value: string) =>
      !value
        ? intl.formatMessage({
            id: "organization.emailValidation",
          })
        : emailRegex.test(value)
        ? ""
        : intl.formatMessage({
            id: "organization.emailAnotherValidation",
          }),
  };

  const handleCancelClick = () => {
    navigate("/admin");
  };

  const nameRegex = new RegExp(/^[a-zA-Z\s.]+$/);
  const emailRegex: RegExp = new RegExp(/\S+@\S+\.\S+/);
  const mobileRegex: RegExp = new RegExp(/^[0-9]{5,15}$/);
  const [countryCode, setCountryCode] = useState<any>();
  const myCountryCodesObject = countryCodes.customList(
    // CountryProperty?.countryCode,
    "countryCode",
    "[{countryCode}] {countryNameEn}: +{countryCallingCode}"
  );

  const myCountryCodesArray = Object.entries(myCountryCodesObject).map(
    ([key, value]) => value
  );

  const extractedData = myCountryCodesArray.map((item: any) => {
    const [countryCodeSome, rest] = item.split("]");
    const [countryNameEn, countryCallingCode] = rest.split(": +");

    return {
      countryCode: countryCodeSome.slice(1),
      countryNameEn,
      item,
      countryCallingCode: `+${countryCallingCode}`,
    };
  });

  const countryList = extractedData.map((item) => {
    return {
      label: item.item,
      value: item.item,
      code: item.countryCode.toLowerCase(),
      countryName: item.countryNameEn,
      countryCallingCode: item.countryCallingCode,
    };
  });

  async function manageAdmin(formData: { [name: string]: any }) {
    if (params?.id) {
      //edit form data
      let data: any = {};
      data.userId = params?.id;
      data["title"] = formData["title"];
      data.fname = formData["fname"];
      data.lname = formData["lname"];
      data.email = formData["email"];
      data.phNo = formData["phNo"];
      data.role = formData["role"];
      data.status = formData["status"];
      let dt = new Date(formData["validUpTo"]).toString();
      // data.validUpTo = formData["validUpTo"];
      data.validUpTo = dt;
      data.aiModel = formData["aiModel"];
      console.log("manage admin data print fadfadsdafsdfas", data);

      let api = ApiServices.getInstance();
      api
        .makeRequest(`MikrosAdminUser/Update`, "POST", data)
        .then(async (data) => {
          if (data && data.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          }
          toggleformUpdateDialog();
          setShowDialogtext(true);
          setShowMessage(false);
        });
    } else {
      // new form data
      const countryCodeIndex = countryCode?.lastIndexOf(":");
      const countryCodeNumber = countryCode
        ?.substring(countryCodeIndex + 1)
        ?.trim();

      console.log("country code", countryCode);

      console.log("country code number", countryCodeNumber);
      let data: any = {};
      data["title"] = formData["title"];
      data.fname = formData["fname"];
      data.lname = formData["lname"];
      data.email = formData["email"];
      data.phNo = countryCodeNumber && countryCodeNumber + formData["phNo"];
      data.role = formData["role"];
      data.status = formData["status"];
      data.aiModel = formData["aiModel"];
      let dt = new Date(formData["validUpTo"]).toString();
      // data.validUpTo = formData["validUpTo"]
      //   ? formData["validUpTo"].getTime()
      //   : "";
      data.validUpTo = dt;
      console.log("print ai model being sent in form", formData["aiModel"]);
      console.log("data sent to post admin", data);

      if (!countryCodeNumber && formData["phNo"] !== undefined) {
        console.log("inside undefined of country code");
        let err: any = {};
        err.noCountryCode = {
          error: intl.formatMessage({ id: "users.createUser.countryCode" }),
        };
        setErrors(err);
        return false;
      }

      let api = ApiServices.getInstance();
      api.makeRequest(`MikrosAdminUser`, "POST", data).then(async (data) => {
        if (data && data.errorMessage) {
          setErrorFlag(true);
          await errorInstance.updateErrorCode(data.errorMessage);
          return;
        }
        toggleformCreateDialog();
        setShowDialogtext(true);
        setShowMessage(true);
      });
    }
  }

  React.useEffect(() => {
    let initialValuesData = {};
    if (params?.id) {
      let api = ApiServices.getInstance();
      api
        .makeRequest(`MikrosAdminUser/${params?.id}`, "GET")
        .then(async (data) => {
          if (data && data.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          }
          console.log("manage admin user data", data);
          console.log("role print in manage admin data", data.role);

          const role = data?.role;
          let roleName;

          // switch (role) {
          //   case "adm_superAdmin":
          //     roleName = "Super Admin";
          //     break;
          //   case "adm_contentCreator":
          //     roleName = "Content Creator";
          //     break;
          //   case "adm_reviewer":
          //     roleName = "Reviewer";
          //     break;
          //   case "adm_L1Admin":
          //     roleName = "L1 Admin";
          //     break;
          //   default:
          //     break;
          // }
          switch (role) {
            case "adm_superAdmin":
              // return intl.formatMessage({ id: "adminList.superAdmin" });
              roleName = intl.formatMessage({ id: "adminList.superAdmin" });
              break;
            case "adm_contentCreator":
              roleName = intl.formatMessage({ id: "adminList.contentCreator" });
              break;
            case "adm_reviewer":
              roleName = intl.formatMessage({ id: "adminList.reviewer" });
              break;
            case "adm_L1Admin":
              roleName = intl.formatMessage({ id: "adminList.l1Admin" });
              break;
            default:
              break;
          }

          //  console.log(data);
          initialValuesData = {
            fname: data.fname,
            lname: data.lname,
            phNo: data.phNo,
            // access: data.role,
            // role: data.role,
            role: roleName,
            status: data.status,
            validUpTo: data.validUpTo,
            email: data.email,
            aiModel: complexSimpleModelMapping[data.aiModel],

            // aiModel:complexSimpleModelMapping[data.aiModel],
            // aiModel: complexSimpleModelMapping[data.aiModel],
            // aiModel: "gpt3p5",
          };
          settoggle(true);
          setShowButton(false);
          setShowAdminUser(initialValuesData);
          console.log(
            "initial values data in manage admin adfdafsfdfd",
            initialValuesData
          );
          setExtractRole(data.role);
        });
    } else {
      initialValuesData = {
        fname: "",
        lname: "",
        phNo: "",
        role: "",
        // status: "Enabled",
        status: intl.formatMessage({
          id: "manageAdmin.initialStatus",
        }),
        validUpTo: "",
        email: "",
        aiModel: intl.formatMessage({
          id: "manageAdmin.initialModel",
        }),
      };

      settoggle(true);
      setShowButton(true);
      setShowAdminUser(initialValuesData);
    }
  }, []);

  console.log("print role set", extractRole);

  return (
    <div>
      <div className="mt-2">
        <div className="text-mk-primary-bright text-xl font-bold">
          <FormattedMessage id="createAdmin.ManageAdmin" />
        </div>
        {errorFlag && (
          <Dialog className="errorDialogue">
            <Alert
              description={intl.formatMessage({
                id: errorInstance.errorCode,
              })}
              buttonText={`${intl.formatMessage({
                id: "users.buttonText.Ok",
              })}`}
              icon={"errorShape.png"}
              iconMsg={intl.formatMessage({
                id: "iconMsgError",
              })}
              backgroundColor={"mk-red"}
              onClick={() => {
                setErrorFlag(false);
                navigate("/admin");
              }}
            />
          </Dialog>
        )}

        {showtoggle && (
          <Form
            initialValues={showAdminUser}
            onSubmit={manageAdmin}
            key={formKey}
            render={(formRenderProps) => (
              <FormElement>
                <div className="grid grid-cols-2">
                  <div>
                    <Field
                      name={"fname"}
                      id={"fname"}
                      label={`${intl.formatMessage({
                        id: "user.createUser.fname",
                      })}`}
                      component={FormMaskedTextBox}
                      validator={validators.firstNameValidator}
                      className="bg-white w-96"
                      maxLength={20}
                    />
                    <div>
                      <Field
                        name={"email"}
                        id={"email"}
                        label={
                          <div>
                            {intl.formatMessage({
                              id: "user.createUser.emailId",
                            })}
                            {"*"}
                          </div>
                        }
                        component={FormMaskedTextBox}
                        validator={validators.emailValidator}
                        className="bg-white w-96"
                        maxLength={50}
                      />

                      <Field
                        name={"aiModel"}
                        id={"aiModel"}
                        label={`${intl.formatMessage({
                          id: "manageAdmin.aiModel",
                        })}`}
                        data={[
                          intl.formatMessage({ id: "gptSimple4o" }),
                          intl.formatMessage({ id: "gptSimple4" }),
                        ]}
                        component={FormDropDownList}
                        className="bg-white w-96"
                        defaultValue={intl.formatMessage({
                          id: "gptSimple3p5",
                        })}
                      />

                      <Field
                        name={"validUpTo"}
                        id={"validUpTo"}
                        label={`${intl.formatMessage({
                          id: "manageAdmin.validUntil",
                        })}`}
                        component={FormDatePicker}
                        className="bg-white w-96"
                      />
                    </div>
                  </div>

                  <div>
                    <div>
                      <Field
                        name={"lname"}
                        id={"lname"}
                        label={`${intl.formatMessage({
                          id: "user.createUser.lname",
                        })}`}
                        component={FormMaskedTextBox}
                        validator={validators.lastNameValidator}
                        className="bg-white w-96"
                        maxLength={20}
                      />
                    </div>

                    {!params?.id && (
                      <div className="flex items-end">
                        <InputPicker
                          cleanable={false}
                          size="sm"
                          // style={{ width: 102 }}
                          style={{
                            width: 102,
                            display: "inline-block",
                            border: "1px solid var(--color-mk-primary)",
                            borderRadius: "4px",
                          }}
                          className="bg-white w-96"
                          onChange={setCountryCode}
                          data={countryList}
                          renderValue={(value, item: any) => {
                            return (
                              <div className="bg-white w-96">
                                <span className={`fi fi-${item?.code}`}></span>
                                {/* &nbsp;{value} */}
                                {item?.countryCallingCode}
                              </div>
                            );
                          }}
                          renderMenuItem={(label, item) => {
                            return (
                              <div>
                                <span className={`fi fi-${item?.code}`}></span>
                                {/* &nbsp;{`${label} (${item?.value})`} */}
                                {`${item?.countryName} (${item?.countryCallingCode})`}
                              </div>
                            );
                          }}
                        />
                        <Field
                          name={"phNo"}
                          id={"phNo"}
                          label={`${intl.formatMessage({
                            id: "manageAdmin.mobileNumber",
                          })}`}
                          maxLength={15}
                          component={FormMaskedTextBoxMobile}
                          validator={validators.mobileNumberValidator}
                          className="bg-white w-72"
                        />
                      </div>
                    )}
                    <Error>{errors.noCountryCode?.error}</Error>

                    {params.id && (
                      <Field
                        name={"phNo"}
                        id={"phNo"}
                        label={`${intl.formatMessage({
                          id: "manageAdmin.mobileNumber",
                        })}`}
                        maxLength={15}
                        component={FormMaskedTextBox}
                        validator={validators.mobileNumberUpdateValidator}
                        className="bg-white w-96"
                      />
                    )}

                    <div>
                      <Field
                        name={"role"}
                        id={"role"}
                        label={`${intl.formatMessage({
                          id: "manageAdmin.adminAccessLevel",
                        })}`}
                        component={FormDropDownList}
                        className="bg-white w-96"
                        data={[
                          intl.formatMessage({ id: "adminList.superAdmin" }),
                          intl.formatMessage({
                            id: "adminList.contentCreator",
                          }),
                          intl.formatMessage({ id: "adminList.reviewer" }),
                          intl.formatMessage({ id: "adminList.l1Admin" }),
                        ]}
                      />
                    </div>
                    <div>
                      <Field
                        name={"status"}
                        id={"status"}
                        label={`${intl.formatMessage({
                          id: "manageAdmin.status",
                        })}`}
                        component={FormDropDownList}
                        className="bg-white w-96"
                        // data={["Enabled", "Disabled"]}
                        data={[
                          intl.formatMessage({
                            id: "manageAdmin.enabledStatus",
                          }),
                          intl.formatMessage({
                            id: "manageAdmin.disabledStatus",
                          }),
                        ]}
                      />
                    </div>

                    <div className="flex gap-4 mt-4">
                      {showButton && (
                        <Button
                          className="rounded-lg bg-mk-primary-bright text-white hover:bg-mk-light-grey
                  hover:text-black focus:outline-none px-4 py-2"
                        >
                          {/* Save */}
                          {intl.formatMessage({
                            id: "user.cohortList.save",
                          })}
                        </Button>
                      )}
                      {!showButton && (
                        <Button
                          className="rounded-lg bg-mk-primary-bright text-white hover:bg-mk-light-grey
                  hover:text-black focus:outline-none px-4 py-2"
                        >
                          {/* Update */}
                          {intl.formatMessage({
                            id: "user.createUser.update",
                          })}
                        </Button>
                      )}

                      <Button
                        key={formKey}
                        onClick={handleCancelClick}
                        className="rounded-lg bg-mk-light-grey text-black hover:bg-mk-light-grey

    hover:text-black focus:outline-none px-4 py-2"
                      >
                        {/* Cancel */}
                        {intl.formatMessage({
                          id: "users.cohortDisplay.cancel",
                        })}
                      </Button>
                      {formCreateDialog && (
                        <Dialog className="confirmSuccessDialogue">
                          <Alert
                            description={`${intl.formatMessage({
                              id: "createMirkrosAdmin.SuccessCreatemessage",
                            })}`}
                            buttonText={`${intl.formatMessage({
                              id: "createCustomer.Ok",
                            })}`}
                            icon={"/successShape.png"}
                            iconMsg={intl.formatMessage({
                              id: "iconMsgSuccess",
                            })}
                            backgroundColor={"mk-bright-green"}
                            onClick={() => {
                              toggleformCreateDialog();
                              navigate("/admin");
                            }}
                          />
                        </Dialog>
                      )}

                      {formUpdateDialog && (
                        <Dialog className="confirmSuccessDialogue">
                          <Alert
                            description={`${intl.formatMessage({
                              id: "createMirkrosAdmin.SuccessUpdatemessage",
                            })}`}
                            buttonText={`${intl.formatMessage({
                              id: "createCustomer.Ok",
                            })}`}
                            icon={"/successShape.png"}
                            iconMsg={intl.formatMessage({
                              id: "iconMsgSuccess",
                            })}
                            backgroundColor={"mk-bright-green"}
                            onClick={() => {
                              toggleformUpdateDialog();
                              navigate("/admin");
                            }}
                          />
                        </Dialog>
                      )}
                    </div>
                  </div>
                </div>
              </FormElement>
            )}
          />
        )}
      </div>
    </div>
  );
}
